module.exports = __webpack_public_path__ + "img/logo.fe9bc22b.png";